var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _circle2, _path9, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromotionImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_20",
    "data-name": "Group 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 246.492,
    height: 155.333,
    viewBox: "0 0 246.492 155.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01ced1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#14b1e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2992fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 3.464,
    y1: 10.761,
    x2: 3.464,
    y2: 9.8,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 3.038,
    y1: 10.738,
    x2: 3.038,
    y2: 9.777,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 3.073,
    y1: 10.062,
    x2: 3.073,
    y2: 9.102,
    xlinkHref: "#linear-gradient-20"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_348",
    "data-name": "Rectangle 348",
    width: 116.959,
    height: 66.431,
    transform: "translate(0 7.622)",
    fill: "url(#linear-gradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_349",
    "data-name": "Rectangle 349",
    width: 114.152,
    height: 55.206,
    transform: "translate(1.249 17.292)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_350",
    "data-name": "Rectangle 350",
    width: 39.609,
    height: 41.793,
    transform: "translate(9.044 21.971)",
    fill: "url(#linear-gradient)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_351",
    "data-name": "Rectangle 351",
    width: 37.428,
    height: 39.922,
    transform: "translate(10.293 22.906)",
    fill: "#e0e0e0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_352",
    "data-name": "Rectangle 352",
    width: 114.152,
    height: 8.421,
    transform: "translate(1.249 8.871)",
    opacity: 0.2,
    fill: "url(#linear-gradient-3)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_353",
    "data-name": "Rectangle 353",
    width: 43.352,
    height: 2.807,
    transform: "translate(63.001 34.601)",
    fill: "#e0e0e0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_354",
    "data-name": "Rectangle 354",
    width: 43.352,
    height: 2.807,
    transform: "translate(63.001 46.452)",
    fill: "#f5f5f5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_355",
    "data-name": "Rectangle 355",
    width: 25.574,
    height: 2.807,
    transform: "translate(62.691 40.528)",
    fill: "#08c4bb",
    opacity: 0.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_356",
    "data-name": "Rectangle 356",
    width: 17.465,
    height: 2.807,
    transform: "translate(62.691 52.379)",
    fill: "#69f0ae",
    opacity: 0.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_357",
    "data-name": "Rectangle 357",
    width: 17.465,
    height: 2.807,
    transform: "translate(83.274 52.379)",
    fill: "#69f0ae"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_358",
    "data-name": "Rectangle 358",
    width: 116.959,
    height: 66.431,
    transform: "translate(124.294 7.622)",
    fill: "url(#linear-gradient)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_359",
    "data-name": "Rectangle 359",
    width: 114.152,
    height: 55.206,
    transform: "translate(125.542 17.292)",
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_360",
    "data-name": "Rectangle 360",
    width: 39.609,
    height: 41.793,
    transform: "translate(133.338 21.971)",
    fill: "url(#linear-gradient)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_361",
    "data-name": "Rectangle 361",
    width: 37.428,
    height: 39.922,
    transform: "translate(134.586 22.906)",
    opacity: 0.8,
    fill: "url(#linear-gradient-3)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M690.321,276a26.454,26.454,0,0,0-1.606-6.966,11.519,11.519,0,0,0-4.4-5.516,5.028,5.028,0,0,0-2.43-.838,4.579,4.579,0,0,0-3.877,2.38,11.1,11.1,0,0,0-.723,1.472,3.427,3.427,0,0,0-2.843,3.139,8.737,8.737,0,0,0,1.235,16.5v1.489a8.768,8.768,0,0,0-6.55,8.455v4.056h17.477v-4.064a8.768,8.768,0,0,0-6.55-8.455v-1.489a8.737,8.737,0,0,0,6.55-8.458v-.061l.983,2.187c.936,2.084,1.894,4.318,1.528,6.575C690.911,283.337,690.763,279.53,690.321,276Z",
    transform: "translate(-526.575 -237.334)",
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_362",
    "data-name": "Rectangle 362",
    width: 114.152,
    height: 8.421,
    transform: "translate(125.542 8.871)",
    opacity: 0.2,
    fill: "url(#linear-gradient-3)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_363",
    "data-name": "Rectangle 363",
    width: 43.352,
    height: 2.807,
    transform: "translate(187.295 34.601)",
    fill: "#e0e0e0"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_364",
    "data-name": "Rectangle 364",
    width: 43.352,
    height: 2.807,
    transform: "translate(187.295 46.452)",
    fill: "#f5f5f5"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_365",
    "data-name": "Rectangle 365",
    width: 25.574,
    height: 2.807,
    transform: "translate(186.985 40.528)",
    fill: "#08c4bb",
    opacity: 0.2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_366",
    "data-name": "Rectangle 366",
    width: 17.465,
    height: 2.807,
    transform: "translate(186.985 52.379)",
    fill: "#69f0ae",
    opacity: 0.2
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_367",
    "data-name": "Rectangle 367",
    width: 17.465,
    height: 2.807,
    transform: "translate(207.567 52.379)",
    fill: "#69f0ae"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_368",
    "data-name": "Rectangle 368",
    width: 116.959,
    height: 66.431,
    transform: "translate(124.294 88.902)",
    fill: "url(#linear-gradient)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_369",
    "data-name": "Rectangle 369",
    width: 114.152,
    height: 55.206,
    transform: "translate(125.542 98.572)",
    fill: "#fff"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_370",
    "data-name": "Rectangle 370",
    width: 39.609,
    height: 41.793,
    transform: "translate(133.338 103.25)",
    fill: "url(#linear-gradient)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_371",
    "data-name": "Rectangle 371",
    width: 37.428,
    height: 39.922,
    transform: "translate(134.586 104.186)",
    opacity: 0.8,
    fill: "url(#linear-gradient-3)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_372",
    "data-name": "Rectangle 372",
    width: 114.152,
    height: 8.421,
    transform: "translate(125.542 90.151)",
    opacity: 0.2,
    fill: "url(#linear-gradient-3)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_373",
    "data-name": "Rectangle 373",
    width: 43.352,
    height: 2.807,
    transform: "translate(187.295 115.881)",
    fill: "#e0e0e0"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_374",
    "data-name": "Rectangle 374",
    width: 43.352,
    height: 2.807,
    transform: "translate(187.295 127.732)",
    fill: "#f5f5f5"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_375",
    "data-name": "Rectangle 375",
    width: 25.574,
    height: 2.807,
    transform: "translate(186.985 121.808)",
    fill: "#08c4bb",
    opacity: 0.2
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_376",
    "data-name": "Rectangle 376",
    width: 17.465,
    height: 2.807,
    transform: "translate(186.985 133.659)",
    fill: "#69f0ae",
    opacity: 0.2
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_377",
    "data-name": "Rectangle 377",
    width: 17.465,
    height: 2.807,
    transform: "translate(207.567 133.659)",
    fill: "#69f0ae"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_378",
    "data-name": "Rectangle 378",
    width: 116.959,
    height: 66.431,
    transform: "translate(0 88.902)",
    fill: "url(#linear-gradient)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_379",
    "data-name": "Rectangle 379",
    width: 114.152,
    height: 55.206,
    transform: "translate(1.249 98.572)",
    fill: "#fff"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_380",
    "data-name": "Rectangle 380",
    width: 39.609,
    height: 41.793,
    transform: "translate(9.323 103.809)",
    fill: "url(#linear-gradient)"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_381",
    "data-name": "Rectangle 381",
    width: 37.428,
    height: 39.922,
    transform: "translate(10.293 104.186)",
    opacity: 0.8,
    fill: "url(#linear-gradient-3)"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_382",
    "data-name": "Rectangle 382",
    width: 114.152,
    height: 8.421,
    transform: "translate(1.249 90.151)",
    opacity: 0.2,
    fill: "url(#linear-gradient-3)"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_383",
    "data-name": "Rectangle 383",
    width: 43.352,
    height: 2.807,
    transform: "translate(63.001 115.881)",
    fill: "#e0e0e0"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_384",
    "data-name": "Rectangle 384",
    width: 43.352,
    height: 2.807,
    transform: "translate(63.001 127.732)",
    fill: "#f5f5f5"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_385",
    "data-name": "Rectangle 385",
    width: 25.574,
    height: 2.807,
    transform: "translate(62.691 121.808)",
    fill: "#08c4bb",
    opacity: 0.2
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_386",
    "data-name": "Rectangle 386",
    width: 17.465,
    height: 2.807,
    transform: "translate(62.691 133.659)",
    fill: "#69f0ae",
    opacity: 0.2
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_387",
    "data-name": "Rectangle 387",
    width: 17.465,
    height: 2.807,
    transform: "translate(83.274 133.659)",
    fill: "#69f0ae"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M241.421,595.484v-1.416a8.938,8.938,0,1,0-4.469,0v1.416a8.692,8.692,0,0,0-6.424,8.363v3.91h17.317v-3.91A8.692,8.692,0,0,0,241.421,595.484Z",
    transform: "translate(-210.278 -463.482)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 9.497,
    cy: 9.497,
    r: 9.497,
    transform: "translate(19.412 110.479)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M278.928,603.83s-.534,10.237,3.656,11.354c0,0-8.659,4.748-10.335-5.586Z",
    transform: "translate(-240.548 -483.195)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M218.906,603.83s.533,10.237-3.656,11.354c0,0,8.659,4.748,10.335-5.586Z",
    transform: "translate(-199.469 -483.195)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M235.074,283.2a6.679,6.679,0,0,1-.735-3.463,4.631,4.631,0,0,1,1.525-3.142,6.377,6.377,0,0,1,3.676-1.262,34.9,34.9,0,0,0,3.938-.3,8.231,8.231,0,0,0,5.257-3.564,11.07,11.07,0,0,1-.028,3.031,3.784,3.784,0,0,1-1.57,2.514c1.045-.483.933.651.7,1.33.52.626,1.776.729,1.841,1.539a5.1,5.1,0,0,1-.263,2.394c-.316.746.022,2.061-.785,2.12",
    transform: "translate(-213.218 -243.667)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M282.3,289.92s4.595.4,1.324,7.223",
    transform: "translate(-247.791 -256.964)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M241.421,304.484v-1.416a8.938,8.938,0,1,0-4.469,0v1.416a8.692,8.692,0,0,0-6.424,8.363v3.91h17.317v-3.91A8.692,8.692,0,0,0,241.421,304.484Z",
    transform: "translate(-210.278 -253.761)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M684.421,595.614V594.2a8.938,8.938,0,1,0-4.469,0v1.416a8.692,8.692,0,0,0-6.424,8.363v3.91h17.317v-3.91A8.692,8.692,0,0,0,684.421,595.614Z",
    transform: "translate(-529.543 -463.576)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 9.497,
    cy: 9.497,
    r: 9.497,
    transform: "translate(143.147 111.317)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M686.055,558.874a12.51,12.51,0,0,0,2.274-.609,3.712,3.712,0,0,0,2.1-3.315,6.424,6.424,0,0,1,.941,1.86,2,2,0,0,1,.1,1.1.863.863,0,0,1-.788.676,3.794,3.794,0,0,0,2.218-.017,1.293,1.293,0,0,0,.673-1.832,5.611,5.611,0,0,1,1.045,1.494,1.9,1.9,0,0,1-.078,1.757,2.324,2.324,0,0,1-2.031.8q1,.062,2.011.05a1.933,1.933,0,0,0,1.084-.235.7.7,0,0,0,.223-.972,4.514,4.514,0,0,1-.818,4.908c-.793.824-1.916,1.352-2.475,2.349a10.254,10.254,0,0,0-.637,1.955,5.65,5.65,0,0,1-1.221,2.109,3.656,3.656,0,0,1-2.332,1.265,4.27,4.27,0,0,1-3.257-1.609,27.489,27.489,0,0,0-2.514-2.793c-1.4-1.145-3.424-1.416-4.734-2.617a15.613,15.613,0,0,1,3.648-3.843A11.451,11.451,0,0,1,686.055,558.874Z",
    transform: "translate(-532.852 -447.968)",
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 12.848,
    cy: 12.848,
    r: 12.848,
    transform: "translate(96.781 0.151)",
    fill: "url(#linear-gradient)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 12.848,
    cy: 12.848,
    r: 12.848,
    transform: "translate(220.796 0.151)",
    fill: "url(#linear-gradient)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 12.848,
    cy: 12.848,
    r: 12.848,
    transform: "translate(96.781 81.43)",
    fill: "url(#linear-gradient)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 12.848,
    cy: 12.848,
    r: 12.848,
    transform: "translate(220.796 81.43)",
    fill: "url(#linear-gradient)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 11.731,
    cy: 11.731,
    r: 11.731,
    transform: "translate(97.899 1.268)",
    fill: "#fff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 11.731,
    cy: 11.731,
    r: 11.731,
    transform: "translate(97.899 82.548)",
    fill: "#fff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 11.731,
    cy: 11.731,
    r: 11.731,
    transform: "translate(221.913 82.548)",
    fill: "#fff"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 11.731,
    cy: 11.731,
    r: 11.731,
    transform: "translate(221.913 1.268)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M826.864,2.564,822.75,0l-7.907,12.611L809.5,9.326l-2.659,4.257,7.765,4.7h0l1.933,1.235Z",
    transform: "translate(-581.481)",
    fill: "url(#linear-gradient-20)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M827.739,3.192,824.013.93,816.2,13.8l-5.48-3.329-2.265,3.726,7.343,4.452h0l1.88,1.114Z",
    transform: "translate(-582.641 -0.67)",
    fill: "url(#linear-gradient-3)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M826.864,290.564,822.75,288l-7.907,12.611-5.343-3.285-2.659,4.257,7.765,4.7h0l1.933,1.235Z",
    transform: "translate(-581.481 -207.558)",
    fill: "url(#linear-gradient-22)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M827.739,291.192l-3.726-2.262L816.2,301.8l-5.48-3.329-2.265,3.726,7.343,4.452h0l1.88,1.114Z",
    transform: "translate(-582.641 -208.229)",
    fill: "url(#linear-gradient-3)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M380.864,290.564,376.75,288l-7.907,12.611-5.343-3.285-2.659,4.257,7.765,4.7h0l1.933,1.235Z",
    transform: "translate(-260.053 -207.558)",
    fill: "url(#linear-gradient-24)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M381.739,291.192l-3.726-2.262L370.2,301.8l-5.48-3.329-2.265,3.726,7.343,4.452h0l1.88,1.114Z",
    transform: "translate(-261.214 -208.229)",
    fill: "url(#linear-gradient-3)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionImage);
export default __webpack_public_path__ + "static/media/PromotionImage.a2a9b52fa88330d09329f5760de4e5d7.svg";
export { ForwardRef as ReactComponent };